document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('[data-mobile-menu]');
  const toggles = document.querySelectorAll('[data-menu-toggle]');
  if (drawer && toggles.length) {
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        const open = !drawer.classList.contains('is-open');
        drawer.classList.toggle('is-open', open);
        toggles.forEach(function (button) { button.setAttribute('aria-expanded', open ? 'true' : 'false'); });
        document.body.classList.toggle('menu-open', open);
      });
    });
  }

  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      const panel = button.nextElementSibling;
      if (!panel) return;
      const open = panel.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-product-loader]').forEach(function (section) {
    const button = section.querySelector('[data-load-more-products]');
    if (!button) return;

    button.addEventListener('click', function () {
      const count = parseInt(button.getAttribute('data-load-count'), 10) || 8;
      const hiddenItems = Array.from(section.querySelectorAll('[data-product-loader-item].is-product-hidden'));
      hiddenItems.slice(0, count).forEach(function (item) {
        item.classList.remove('is-product-hidden');
      });

      if (!section.querySelector('[data-product-loader-item].is-product-hidden')) {
        button.hidden = true;
      }
    });
  });


  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
    const items = Array.from(gallery.querySelectorAll('[data-product-media-item]'));
    if (!thumbs.length || !items.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const mediaId = thumb.getAttribute('data-media-id');
        thumbs.forEach(function (button) {
          const active = button === thumb;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        items.forEach(function (item) {
          const active = item.getAttribute('data-media-id') === mediaId;
          item.hidden = !active;
          item.classList.toggle('is-active', active);
          if (!active) {
            item.querySelectorAll('video').forEach(function (video) { video.pause(); });
          }
        });
      });
    });
  });

  document.querySelectorAll('[data-product-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      const option = select.options[select.selectedIndex];
      const price = option ? option.getAttribute('data-price') : null;
      const product = select.closest('.product-detail');
      const priceNode = product ? product.querySelector('.product-price') : null;
      if (price && priceNode) priceNode.textContent = price;
    });
  });

});
